import React, { useContext, useState, useEffect } from 'react'

import PickerCard from '../PickerCard'
import PlansContext from '../../context/Plans'
import SelectedPlanContext from '../../context/SelectedPlan'

/**
 * Component that displays the different ZealStream subscription plans
 *
 * @component
 * @example
 * return (
 *   <PlanPicker />
 * )
*/

const PlanPicker = () => {

    const { plans } = useContext(PlansContext)
    const { selectedPlan } = useContext(SelectedPlanContext)


    return plans ? (
        <div id="planPicker" className="col-md-5 d-flex flex-column gap-3 justify-content-start mb-4 px-0 px-md-2">
            {plans.map(plan => (
                <PickerCard 
                    price={parseFloat(plan.metadata.price_for_fe)}
                    selected={plan.name === selectedPlan.name} 
                    name={plan.name}
                    key={plan.id}
                    details={[plan.metadata.detail1, plan.metadata.detail2, plan.metadata.detail3, plan.metadata.detail4]}
                    summary={plan.description} />
            ))}
        </div>

    ) :  null

}

export default PlanPicker